export default __webpack_public_path__ + "static/media/zanzibar.38c48d8d.jpg";